<template>
  <Suspense>
    <div class="contentWrap">
      <NavBar />
      <Banner />
      <Question />
      <Footer />
    </div>
  </Suspense>
</template>

<script setup>
import NavBar from '@/components/share/navBar.vue';
import Banner from '@/components/FAQ/banner.vue';
import Question from '@/components/FAQ/question.vue';
import Footer from '@/components/share/footer.vue';
import { useMeta } from 'vue-meta';
import router from '@/router';

useMeta({
  title: 'FAQ',
  description: `UniBridge FAQ | Asia preferred rental NFT platform | Rent to earn`,
  meta: [
    {
      property: 'og:title',
      content: `FAQ | Asia preferred rental NFT platform | Rent to earn`,
    },
    {
      property: 'og:description',
      content: `UniBridge FAQ | Asia preferred rental NFT platform | Rent to earn`,
    },
    {
      property: 'og:image',
      content:
        'https://s3.ap-northeast-1.amazonaws.com/unibridge.io/UniBridgeBanner.png',
    },
    {
      property: 'og:url',
      content:
        process.env.VUE_APP_BASE_URL + router.currentRoute.value.fullPath,
    },
  ],
});
</script>
<style lang="less" scoped></style>
